import { Routes } from '@angular/router';

import { settlementsRoutes } from './features/settlements/settlements.routes';
import { tmsRoutes } from './features/tms/tms.routes';

/**
 * Módulo expuesto por `federation.config.js` como `./routes`.
 *
 * Contrato del shell:
 *   loadRemoteModule('settlements', './routes').then(m => m.remoteRoutes)
 * El símbolo exportado TIENE que llamarse `remoteRoutes` — es contrato de la plataforma, no
 * una convención de estilo (`dynamic-routes.service.ts` del shell).
 *
 * ---
 *
 * **Árbol PLANO: sin el `MainLayoutComponent`.** En el portal standalone estas rutas cuelgan
 * de un layout propio que dibuja el sidebar y la topbar. Bajo el shell ese layout ya existe
 * —es el del host—, así que montarlo acá daría dos sidebars y dos barras superiores, una
 * dentro de la otra. El menú de este vertical viaja como DATOS por `./screens` y lo dibuja el
 * topbar del shell.
 *
 * **Las dos familias se concatenan tal cual.** `settlementsRoutes` y `tmsRoutes` ya son
 * hermanas bajo el mismo padre en el portal standalone (las dos entran con `path: ''`), así
 * que concatenarlas conserva exactamente los mismos segmentos: `/waybills`, `/carriers`, …
 * Los `path` que viajan en `./screens` son ESOS, sin barra inicial — el shell antepone su
 * segmento de montaje, que decide él.
 *
 * El `authGuard` del portal no viaja: el punto de montaje del shell ya lo aplica, con el
 * módulo de la fila de `REMOTE_SCREENS` como `data.id`.
 */
export const remoteRoutes: Routes = [
    {
        // Contenedor MÍNIMO del vertical: un `<router-outlet>` y nada más. No es el
        // `MainLayoutComponent` de vuelta —no trae sidebar, ni topbar, ni el selector de
        // cliente, que ahora se declara por `./context-bar` y lo dibuja el host—; existe sólo
        // porque estas hijas necesitan un padre con outlet donde activarse. Ver el docblock de
        // `SettlementsShellComponent`.
        path: '',
        loadComponent: () =>
            import('./shell/settlements-shell.component').then((m) => m.SettlementsShellComponent),
        children: [...settlementsRoutes, ...tmsRoutes],
    },
];
